import React, { Component } from 'react';
import './index.css';
import {
  imageBasePath,
  isDevelopment,
  triTipWidthOfPedigreeCallOutBox,
  widthOfPedigreeCallOutBox,
} from '../../../library/constants';
import { getOffset } from '../../../library/calc';

import Parents from '../../ImmediateFamily/parents.js';


export class Addbox extends Parents {

  getNumberOfDomRowsfromImmediateFamily(){

    const { nodeObjs, addNodeFormFocus} = this.props;
    const immediateFam = nodeObjs[addNodeFormFocus].immediateFam;

    const keysToIgnore = ['partnersObj', 'partnerOrder', 'parentPairs', 'allPotentialParentPairs']

    let domRowsfromImmediateFamily = 0;
    for( var key in immediateFam){
      if( !keysToIgnore.includes(key) ){

        if( key === 'siblings' && immediateFam['siblings'].length > 0){
          domRowsfromImmediateFamily += immediateFam[key].length - 1; /* Siblings will not include the pedigree focus */
          // console.log(`a) key adding: `, key, ' - ', immediateFam[key].length);
        } else {
          // console.log(`b) key adding: `, key, ' - ', immediateFam[key].length);
          domRowsfromImmediateFamily += immediateFam[key].length;

        }
        // console.log(`domRowsfromImmediateFamily: `, domRowsfromImmediateFamily);
        if( key === 'partners' && immediateFam['partners'].length > 0) {
          this.numberOfPartners = immediateFam['partners'].length;
        }
      }
    }
    return domRowsfromImmediateFamily;
  }

  getAddBoxStyle(){

    const { nodeObjs, addNodeFormFocus} = this.props;
    const immediateFam = nodeObjs[addNodeFormFocus].immediateFam;


    let heightOfCallOutContainer = this.defaultHeightOfMockCallOutContainer;
    let domRowsfromImmediateFamily = this.defaultMockSiblingRows;
    let pedigreeInnerTableWrapperHeight = '100%';
    const paddingAndMarginOfTable = 26;

    if(this.immediateFamilyIsFetched()){

      const noParents = immediateFam.parents.length === 0;
      const noSiblings = immediateFam.siblings.length === 0;
      const noPartners = immediateFam.partners.length === 0;
      const noChildren = immediateFam.children.length === 0;
      domRowsfromImmediateFamily = this.getNumberOfDomRowsfromImmediateFamily();


      if(this.hasOnlyOnePartner()){
        // console.log('hasOnlyOnePartner');
        // console.log(`domRowsfromImmediateFamily: `, domRowsfromImmediateFamily);
        // if(!this.canAddNode()) {
        //   console.log('!canAddNode');
        // }
        heightOfCallOutContainer = this.defaultHeadersHeightSinglePartner +
                                  (this.pixelsHeightForEachDomRow * domRowsfromImmediateFamily) +
                                  this.combineHeightOfHrSeparatorsSinglePartner +
                                  this.marginOfInnerTableWrapper;
      } else{
        // console.log('hasMutilplePartner');
        heightOfCallOutContainer = this.defaultHeadersHeightMultiPartner +
                                  (this.pixelsHeightForEachDomRow * domRowsfromImmediateFamily) +
                                  (this.addSonAndDaughterDivHeight * this.numberOfPartners ) +
                                  this.combineHeightOfHrSeparatorsMultiPartner +
                                  this.marginOfInnerTableWrapper;


        if(!this.canAddNode()) {
          // console.log('!canAddNode');
          heightOfCallOutContainer -= (this.numberOfPartners * 22) + 16
        }

        // console.log(`this.numberOfPartners: `, this.numberOfPartners);
        // console.log(`domRowsfromImmediateFamily: `, domRowsfromImmediateFamily);
        // console.log(`heightOfCallOutContainer: `, heightOfCallOutContainer);
      }

      if(noSiblings && !this.canAddNode()) heightOfCallOutContainer -= this.pixelsHeightForEachDomRow + this.defaultHeadersHeight;
      if(noParents && !this.canAddNode()) heightOfCallOutContainer -= this.pixelsHeightForEachDomRow + this.defaultHeadersHeight;
      if(noPartners && !this.canAddNode()) heightOfCallOutContainer -= this.pixelsHeightForEachDomRow + this.defaultHeadersHeight;
      if(noChildren && !this.canAddNode()) heightOfCallOutContainer -= this.pixelsHeightForEachDomRow + this.defaultHeadersHeight;


      if(typeof(window.doThisOnce) === 'undefined') window.doThisOnce = false;
/*
      if(!window.doThisOnce){
        window.doThisOnce = true;

          console.log(`this.defaultHeadersHeightMultiPartner: `, this.defaultHeadersHeightMultiPartner);
          console.log(`domRowsfromImmediateFamily: `, domRowsfromImmediateFamily);
          console.log(`this.pixelsHeightForEachDomRow: `, this.pixelsHeightForEachDomRow);
          console.log(`this.combineHeightOfHrSeparatorsSinglePartner: `, this.combineHeightOfHrSeparatorsSinglePartner);
          console.log(`this.combineHeightOfHrSeparatorsMultiPartner: `, this.combineHeightOfHrSeparatorsMultiPartner);
          console.log(`this.marginOfInnerTableWrapper: `, this.marginOfInnerTableWrapper);
          console.log(`this.addSonAndDaughterDivHeight: `, this.addSonAndDaughterDivHeight);
          console.log(`this.numberOfPartners: `, this.numberOfPartners);
          console.log('************************************');
          console.log(`(this.pixelsHeightForEachDomRow * domRowsfromImmediateFamily): `, (this.pixelsHeightForEachDomRow * domRowsfromImmediateFamily));
          console.log('************************************');
          console.log('************************************');
          console.log(`heightOfCallOutContainer: `, heightOfCallOutContainer);
          // const el = document.querySelector('#addBox-callout')
          // setTimeout(() => {
          //   console.log(`window.getComputedStyle(el).getPropertyValue('height'): `, window.getComputedStyle(el).getPropertyValue('height'));
          // }, 1000);

      }
*/
      // if( document.querySelector('#pedigree-innerTable-wrapper') !== null &&
      //     heightOfCallOutContainer > this.props.canvasHeight){
      //   document.querySelector('#pedigree-innerTable-wrapper').style.height = `${this.props.canvasHeight - paddingAndMarginOfTable}px`;
      // }

    }

    const shiftUpBuffer = 6
    let top = this.props.pedigreeAddboxTop - ( (heightOfCallOutContainer - paddingAndMarginOfTable)/2 )  - shiftUpBuffer;


    /*
      *
      *
      *   Callout is lower than bottom
      *
      *
     */

     // if(typeof(window.doThisOnce) === 'undefined') window.doThisOnce = false;

     // if(!window.doThisOnce){
     //   window.doThisOnce = true;


     //    console.log(`top: `, top);
     //    console.log(`heightOfCallOutContainer: `, heightOfCallOutContainer);
     //    console.log(`this.props.canvasHeight: `, this.props.canvasHeight);
     //    console.log(`top + (heightOfCallOutContainer): `, top + (heightOfCallOutContainer));
     // }


    if( top + (heightOfCallOutContainer) > this.props.canvasHeight){

      const stageEl = document.getElementById('stageWrapper');
      const stageHeight = parseInt(stageEl.style.height, 10);
      const stageTop = getOffset(stageEl).top;
      const stageBottom = stageTop + stageHeight;
      top = stageBottom - heightOfCallOutContainer - stageTop;

      // if(typeof(window.doThisOnce2) === 'undefined') window.doThisOnce2 = false;

      // if(!window.doThisOnce2 && this.immediateFamilyIsFetched()){
      //   window.doThisOnce2 = true;
      //   console.log('---------------------------------');
      //   console.log(`this.props.canvasHeight: `, this.props.canvasHeight);
      //   console.log(`stageHeight: `, stageHeight);
      //   console.log(`stageTop: `, stageTop);
      //   console.log(`stageBottom: `, stageBottom);
      //   console.log(`heightOfCallOutContainer: `, heightOfCallOutContainer);
      //   console.log(`top of callout: `, top);
      //   console.log('---------------------------------');
      //   console.log(`heightOfCallOutContainer: `, heightOfCallOutContainer);
      //   const el = document.querySelector('#addBox-callout')
      //   setTimeout(() => {

      //   console.log(`window.getComputedStyle(el).getPropertyValue('height'): `, window.getComputedStyle(el).getPropertyValue('height'));
      //   }, 1000);
    // }


      // top = (this.props.canvasHeight - heightOfCallOutContainer);

      // console.log(`document.getElementById('stageWrapper').style.height: `, document.getElementById('stageWrapper').style.height);
      // console.log(`getOffset(document.getElementById('stageWrapper')).top: `, getOffset(document.getElementById('stageWrapper')).top);

      /*
        *
        *
        Or maybe try using tritip for placement of callout
        *
        *
        *
       */

      // const headerTop = ( !isDevelopment ? document.getElementById('header').offsetTop: 0);

      // const heightOfTriTipPoint = 50;
      // const heightOfTriTipPoint = 50;
      // let triTipPoint = this.props.pedigreeAddboxTop +
      //     (this.props.canvasTop / this.props.scaleX) +
      //     (heightOfTriTipPoint / 2) ;
      // triTipPoint += headerTop;

      // console.log(`this.props.pedigreeAddboxTop: `, this.props.pedigreeAddboxTop);
      // console.log(`this.props.canvasTop: `, this.props.canvasTop);
      // console.log(`this.props.scaleX: `, this.props.scaleX);
      // console.log(`heightOfTriTipPoint: `, heightOfTriTipPoint);
      // console.log(`heightOfCallOutContainer: `, heightOfCallOutContainer);

      // top = triTipPoint - heightOfCallOutContainer + 2 /* a little buffer */;
    } else{
      // console.log('less than bottom');
    }


    /*
      *
      *
      *   Callout is HUGE
      *
      *
     */

    if( heightOfCallOutContainer > this.props.canvasHeight ) {
      pedigreeInnerTableWrapperHeight = `${this.props.canvasHeight - paddingAndMarginOfTable}px`;
    }

    if( top < 0) {
      top = 0;
    }

    const left = this.props.pedigreeAddboxLeft + triTipWidthOfPedigreeCallOutBox;

    heightOfCallOutContainer = ( heightOfCallOutContainer > this.props.canvasHeight ? this.props.canvasHeight : heightOfCallOutContainer);

    const addBox = {
      position: 'absolute',
      left: `${left}px`,
      top: `${top}px`,
      width: `${widthOfPedigreeCallOutBox}px`,
      height: ( this.immediateFamilyIsFetched() ? 'auto': `${this.defaultHeightOfMockCallOutContainer}px`),
      backgroundColor: 'white',
      MozBoxShadow: '0 2px 5px 0 rgba(0,0,0,0.12),  0 2px 5px 0 rgba(0,0,0,0.12)',
      webKitboxShadow: '0 2px 5px 0 rgba(0,0,0,0.12),  0 2px 5px 0 rgba(0,0,0,0.12)',
      boxShadow: '0 2px 5px 0 rgba(0,0,0,0.12),  0 2px 5px 0 rgba(0,0,0,0.12)',
      transform: `translateX(${( this.props.flipPanelOpened ? 185: 0)}px)`,
      zIndex: 1,
    }


    return {
      addBox,
      heightOfCallOutContainer,
      pedigreeInnerTableWrapperHeight,
    }
  }


  render () {

    const showProgressIndicator = () => {

      if(this.immediateFamilyIsFetched()) {
        return null
      } else {

        return <img id="progressIndicator" alt="" src={imageBasePath + 'loading.gif' } style={{
          width: `${50}px`,
          height: `${50}px`,
          position: 'absolute',
          top: '0px',
          bottom: '0',
          left: '-10px',
          right: '0',
          margin: 'auto',
        }}/>

      }

    }

    return (
      <div
        id='addBox-callout'
        style={{...this.getAddBoxStyle().addBox}}>
        {
          showProgressIndicator()

        }
        <div
          style={{
            top: `0px`,
            right: `0px`,
            width: '15px',
            height: `25px`,
            position: 'absolute',
            color: 'rgba(0, 0, 0, 0.45)',
            cursor: 'pointer',
          }}
          className={'ant-notification-notice-close-x closeButton'}
          onClick={()=>{
            this.props.setPedigreeAddbox({visible: false});
          }}
        ></div>
        <div
          id='pedigree-innerTable-wrapper'
          style={{
            height: this.getAddBoxStyle().pedigreeInnerTableWrapperHeight,
          }}>
          {
            this.getImmediateFamilyTableDom()
          }
        </div>
      </div>
    );

  }
}


export class CalloutTriTip extends Component {


  render () {

    const tipWidth = 35;

    const headerTop = ( !isDevelopment ? document.getElementById('header').offsetTop: 0 );

    // console.log(`headerTop: `, headerTop);
    // console.log(`this.props.pedigreeAddboxTop: `, this.props.pedigreeAddboxTop);
    // console.log(`this.props.canvasTop: `, this.props.canvasTop);
    // console.log(`this.props.scaleX: `, this.props.scaleX);

    let top = this.props.pedigreeAddboxTop + 50
    top += headerTop;
    let left = this.props.pedigreeAddboxLeft + 10;

    if( this.props.whichSideTip === 'right' ){

      left += widthOfPedigreeCallOutBox + 25;

      return  (
        <div
              id='addBox-tritip'
              style={{
              zIndex: 1,
              background: `url(${imageBasePath}/move/rightTip.svg) no-repeat `,
              backgroundSize: 'contain',
              width: `${tipWidth}px`,
              height: `50px`,
              position: 'fixed',
              left: `${left}px`,
              top: `${(top)}px`,
              transform: `translateX(${( this.props.flipPanelOpened ? 185: 0)}px)`
              // WebkitTransform: 'rotate(180deg)',
              // MozTransform: 'rotate(180deg)',
              // MsTransform: 'rotate(180deg)',
              // OTransform: 'rotate(180deg)',
              // transform: 'rotate(180deg)',
            }
          }
        />
      )

    } else {

      return  (
        <div
              id='addBox-tritip'
              style={{
              zIndex: 1,
              background: `url(${imageBasePath}/move/leftTip.svg) no-repeat `,
              backgroundSize: 'contain',
              width: `${tipWidth}px`,
              height: `50px`,
              position: 'fixed',
              left: `${left}px`,
              top: `${(top)}px`,
              transform: `translateX(${( this.props.flipPanelOpened ? 185: 0)}px)`
              // WebkitTransform: 'rotate(180deg)',
              // MozTransform: 'rotate(180deg)',
              // MsTransform: 'rotate(180deg)',
              // OTransform: 'rotate(180deg)',
              // transform: 'rotate(180deg)',
            }
          }
        />
      )
    }


  }
}



